<template>
	<v-container fluid>
	<v-layout row wrap>
	<v-flex xs12>
	<v-card text class="position-relative">
	   <v-snackbar
		ma-10
		v-model="snackbar"
		:color="snackbarColor"
		:top="true"
		:right="true"
		:timeout="6000"
		absolute
		>
		{{ message }}
		<v-btn
		  dark
		  text
		  @click="snackbar = false"
		>
		  CLOSE
		</v-btn>
	  </v-snackbar>
	  <div v-if="submitting" class="submitting-overlay">
		<div class="submitting-message">
		  <v-progress-circular indeterminate color="primary" size="36"></v-progress-circular>
		  <div class="subtitle-1 mt-2">Submitting...</div>
		</div>
	  </div>
	  <v-form ref="form" lazy-validation>
		<v-stepper v-model="e1">
		  <v-stepper-header>
		 <v-stepper-step
      :complete="e1 > 1"
      step="1"
      :rules="[() =>
        !errors.has('organizationName') &&
        !errors.has('organizationCode') &&
        !errors.has('organizationType') &&
        !errors.has('identificationDocumentID') &&
        !errors.has('address') &&
        !errors.has('postalCode') &&
        !errors.has('millerId')
      ]"
    >
      Organization Details
    </v-stepper-step>

    <v-divider></v-divider>

    <v-stepper-step
      :complete="e1 > 2"
      step="2"
      :rules="[() =>
        !errors.has('accountNumber') &&
        !errors.has('accountName') &&
        !errors.has('bankName') &&
        !errors.has('bankSwiftCode') &&
        !errors.has('currency')
      ]"
    >
      {{
        [2, 3, 4, 5, 11].includes(organisation.organisationTypeId)
          ? 'Non-checkoff Settlement Details'
          : 'Checkoff Settlement Details'
      }}
    </v-stepper-step>

    <template v-if="[2,3,4,5,11].includes(organisation.organisationTypeId)">
      <v-divider></v-divider>

      <v-stepper-step
        :complete="e1 > 3"
        step="3"
        :rules="[() =>
          !errors.has('accountNumber') &&
          !errors.has('accountName') &&
          !errors.has('bankName') &&
          !errors.has('bankSwiftCode') &&
          !errors.has('currency')
        ]"
      >
        Checkoff Settlement Details
      </v-stepper-step>
    </template>
  </v-stepper-header>
		  <v-stepper-items>
			<v-stepper-content step="1">
			  <v-container grid-list-xl fluid>
				<v-layout wrap>
				  <v-flex xs6>
					<v-text-field
					  name="organizationName"
					  label="Name"
					  v-model="organisationNameUpper"
					  v-validate="'required'"
					  :error-messages="errors.collect('organizationName')">
					</v-text-field>
				  </v-flex>
				  <v-flex xs6>
					<v-text-field
					  name="organizationCode"
					  label="Code"
					  v-model="organisationCodeUpper"
					  v-validate="'required'"
					  :error-messages="errors.collect('organizationCode')">
					</v-text-field>
					<v-progress-linear v-if="checkingOrgExists" indeterminate color="primary" height="2" class="mt-2"></v-progress-linear>
					<v-alert v-if="organisationExistsWarning" type="warning" dense class="mt-2">
					  {{ organisationExistsWarning }}
					</v-alert>
				  </v-flex>
				</v-layout>

				 <v-layout wrap>
	<v-flex xs12 sm3>
	  <v-autocomplete
		name="organizationType"
		v-model="organisation.organisationTypeId"
		:items="institutionTypes"
		item-text="name"
		item-value='id'
		label="Organization Type"
		v-validate="'required'"
		:error-messages="errors.collect('organizationType')"
	  />
	</v-flex>

	<v-flex xs12 sm2 v-if="organisation.organisationTypeId == 4">
	  <v-checkbox
		v-model="isChild"
		label="Is Child Org?"
	  />
	</v-flex>

	<!-- Use v-show instead of v-if to prevent unmounting the component -->
	<v-flex xs12 sm4 v-show="isChild">
	  <v-autocomplete
	v-model="selectedParentOrganisation"
	:items="farmersocieties"
	item-text="organisationName"
	item-value="id"
	return-object
	@input="onParentSelect"
	@update:search-input="searchParentOrganisation"
	label="Parent Organisation"
	dense
	clearable
	outlined
	:loading="loading"
  />

	</v-flex>

	<v-flex xs3>
	  <v-text-field
		name="identificationDocumentID"
		label="Identification Document ID"
		v-model="organisation.identificationDocumentID"
		v-validate="'required'"
		:error-messages="errors.collect('identificationDocumentID')"
	  />
	</v-flex>
  </v-layout>
  <v-layout wrap v-if="organisation.organisationTypeId == 4 || organisation.organisationTypeId == 11">
				  <v-flex xs12 sm4>
					<v-autocomplete
					  name="miller"
            data-vv-name="millerId"
					  v-model="organisation.millerId"
					  :items="millers"
					  item-text="name"
					  item-value='id'
					  label="Miller"
            clearable
					  v-validate="'required'"
					  :error-messages="errors.collect('millerId')">
					  >
					</v-autocomplete>
				  </v-flex>

				  <v-flex xs12 sm4>
					<v-autocomplete
					  name="warehouse"
            data-vv-name="warehouseId"
					  v-model="organisation.warehouseId"
					  :items="warehouse"
					  item-text="name"
					  item-value='id'
					  label="Warehouse"
            clearable
					  v-validate="'required'"
					  :error-messages="errors.collect('warehouseId')">
					  >
					</v-autocomplete>
				  </v-flex>
          <v-flex xs12 sm4>
            <v-autocomplete
              name="tax"
              data-vv-name="tax"
              v-model="organisation.tax"
              :items="taxtypes"
              item-text="name"
              item-value='id'
              label="Tax Type"
              clearable
              :error-messages="errors.collect('tax')">
              >
            </v-autocomplete>

          </v-flex>
				</v-layout>
          <v-layout wrap v-if="organisation.organisationTypeId == 12">
            <v-btn color="primary" @click="addLiabilityProviderLoan" rounded>Add Loan</v-btn>
          </v-layout>
          <div v-if="organisation.organisationTypeId == 12">
          <v-layout v-for="(organisation, index) in liabilityProviderLoans" :key="index" wrap >
            <v-flex xs4>
              <v-text-field
                :name="'loanName_' + index"
                label="Loan Name"
                v-model="organisation.loanName">
              </v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                :name="'loanDisburseAccount_' + index"
                label="Disburse Account"
                @keypress="onlyDigits"
                autocomplete="off"
                v-model="organisation.loanDisburseAccount">
              </v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :name="'loanRecoveryAccount_' + index"
                label="Recovery Account"
                @keypress="onlyDigits"
                autocomplete="off"
                v-model="organisation.loanRecoveryAccount">
              </v-text-field>
            </v-flex>
            <v-flex xs1>
              <v-icon class="tight-icon"
                      slot="prependIcon"
                      @click="removeLiabilityProviderLoan(index)"
                      medium color="#666666"
              >fas fa-times</v-icon
              >
            </v-flex>
          </v-layout>
          </div>
				 <v-layout wrap>
				  <v-flex xs6>
					<v-text-field
					  name="address"
					  label="Address"
					  v-model="organisation.address"
					  v-validate="'required'"
					  :error-messages="errors.collect('address')">
					</v-text-field>
				  </v-flex>
				  <v-flex xs6>
					<v-text-field
					  name="postalCode"
					  label="Postal Code"
					  v-model="organisation.postalCode"
					  v-validate="'required'"
					  :error-messages="errors.collect('postalCode')">
					</v-text-field>
				  </v-flex>
         </v-layout>
          <v-layout wrap>
            <v-flex xs4>
              <v-autocomplete
                name="county"
                v-model="organisation.countyId"
                :items="county"
                item-text="name"
                item-value='id'
                label="County"
                @change="onCountyChange"
                :error-messages="errors.collect('county')"
              />
            </v-flex>
            <v-flex xs4>
              <v-autocomplete
                name="subCounty"
                v-model="organisation.subCountyId"
                :items="subcounty"
                item-text="name"
                item-value='id'
                label="Sub County"
                @change="onSubCountyChange"
                :error-messages="errors.collect('subCounty')"
              />
            </v-flex>
            <v-flex xs4>
              <v-autocomplete
                name="ward"
                v-model="organisation.wardId"
                :items="ward"
                item-text="name"
                item-value='id'
                label="Ward"
                :error-messages="errors.collect('ward')"
              />
            </v-flex>

          </v-layout>
          <v-layout wrap>
            <v-flex xs4>
              <v-text-field
                name="village"
                label="Village"
                v-model="organisation.village"
                @keypress="onlyLetters"
                :error-messages="errors.collect('village')">
              </v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                name="building"
                label="Building"
                v-model="organisation.building"
                :error-messages="errors.collect('building')">
              </v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                name="street"
                label="Street"
                v-model="organisation.street"
                autocomplete="off"
                @keypress="onlyAlphaNumeric"
                :error-messages="errors.collect('street')">
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs4>
              <v-text-field
                name="contactPersonName"
                label="Contact Person Name"
                @keypress="onlyLetters"
                v-model="organisation.contactPersonName"
                :error-messages="errors.collect('contactPersonName')">
              </v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                name="contactPersonPhone"
                label="Contact Person Phone"
                v-model="organisation.contactPersonPhone"
                v-validate="'min:9'"
                maxlength="12"
                @keypress="validateContactPersonPhone"
                @paste="handlePasteContactPersonPhone"
                autocomplete="off"
                :error-messages="errors.collect('contactPersonPhone')">
              </v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                name="contactPersonEmail"
                label="Contact Person Email"
                v-model="organisation.contactPersonEmail"
                v-validate="'email'"
                type="email"
                :error-messages="errors.collect('contactPersonEmail')">
              </v-text-field>
            </v-flex>
				<v-flex xs4>
                  <v-text-field
                    name="kraPin"
                    label="KRA PIN"
                    v-model.trim="organisation.kraPin"
                    :error-messages="errors.collect('kraPin')">
                  </v-text-field>
                </v-flex>
          </v-layout>
          <v-layout wrap>
				  <v-flex xs6>
				  </v-flex>
				  <v-flex>
					<label>Choose Logo
					 <input type="file" id="file" accept="image/jpeg" ref="file" v-on:change="handleFileUpload()" />
				   </label>
				  </v-flex>
				  <v-flex xs12>
					<v-btn color="primary" @click="e1 = 2" rounded>Next</v-btn>
				  </v-flex>
				</v-layout>
			  </v-container>
			</v-stepper-content>
			<v-stepper-content step="2">
			  <v-container grid-list-xl fluid>
				<v-layout wrap>
				  <v-flex xs6>
					<v-text-field
					  name="accountNumber"
					  label="Account No"
            type="number"
					  v-model="organisation.account"
					   :rules="[validateAccountNumber]"
					  :error-messages="errors.collect('accountNumber')"
					  >
					</v-text-field>
				  </v-flex>
				  <v-flex xs6>
					<v-text-field
					  name="accountName"
					  label="Account Name"
					  v-model="organisation.accountName"
					  v-validate="'required'"
					  :error-messages="errors.collect('accountName')"
					>
					</v-text-field>
				  </v-flex>
				  <v-flex xs6>
					<v-autocomplete
					  name="bankName"
					  v-model="organisation.bankName"
					  :items="banks"
					  item-text="bankName"
					  item-value='bankName'
					  label="Bank Name"
					  @input="updateSwiftCode"
					  v-validate="'required'"
					  :error-messages="errors.collect('bankName')">
					  >
					</v-autocomplete>
				  </v-flex>
				  <v-flex xs6>
					<v-text-field
					  name="bankSwiftCode"
					  label="Bank Swift Code"
					  v-model="organisation.bankCode"
					  v-validate="'required'"
					  :error-messages="errors.collect('bankSwiftCode')"
					  disabled
					>
					</v-text-field>
				  </v-flex>
				  <v-flex xs6>
					<v-autocomplete
					   name="currency"
					   v-model="organisation.currency"
					   :items="currencies"
					   label="Currency"
					   v-validate="'required'"
					   :error-messages="errors.collect('currency')"
					   >
					</v-autocomplete>
				  </v-flex>
				  <v-flex xs12>
					<v-card-actions>
					  <v-btn @click="e1 = 1" :disabled="submitting">Back</v-btn>
					  <v-progress-circular v-show="loader" color="red" size="20" indeterminate ></v-progress-circular>
					  <v-spacer> </v-spacer>
					  <v-btn color="primary" @click="e1 = 3" rounded v-if="organisation.organisationTypeId == 4 || organisation.organisationTypeId == 3 || organisation.organisationTypeId == 2 ||  organisation.organisationTypeId == 5  || organisation.organisationTypeId == 11" :disabled="submitting">Next</v-btn>
					  <v-btn color="primary" @click="createOrganization" rounded v-if="organisation.organisationTypeId != 4 && organisation.organisationTypeId != 3 && organisation.organisationTypeId != 2  &&  organisation.organisationTypeId != 5  && organisation.organisationTypeId != 11" :loading="submitting" :disabled="submitting">Create Organization</v-btn>
					</v-card-actions>
				  </v-flex>
				</v-layout>
			  </v-container>
			</v-stepper-content>

			<v-stepper-content step="3">
			  <v-container grid-list-xl fluid>
				<v-layout wrap>
				  <v-flex xs6>
					<v-text-field
					  name="checkoffAccountNumber"
					  label="Account No"
            type="number"
					  v-model="organisation.checkoffAccountNumber"
					  v-validate="organisation.organisationTypeId === 4 ? 'required' : ''"

					  :error-messages="errors.collect('checkoffAccountNumber')">
					</v-text-field>
				  </v-flex>
				  <v-flex xs6>
					<v-text-field
					  name="checkoffAccountName"
					  label="Account Name"

					  v-model="organisation.checkoffAccountName"
					  v-validate="organisation.organisationTypeId === 4 ? 'required' : ''"
					  :error-messages="errors.collect('checkoffAccountName')"
					>
					</v-text-field>
				  </v-flex>
				  <v-flex xs6>
					<v-autocomplete
					  name="checkoffBankName"
					  v-model="organisation.checkoffBankName"
					  :items="banks"
					  item-text="bankName"
					  item-value='bankName'
					  label="Bank Name"
					  @input="checkoffUpdateSwiftCode"
					  v-validate="organisation.organisationTypeId === 4 ? 'required' : ''"
					  :error-messages="errors.collect('checkoffBankName')">
					  >
					</v-autocomplete>
				  </v-flex>
				  <v-flex xs6>
					<v-text-field
					  name="checkoffBankSwiftCode"
					  label="Bank Swift Code"
					  v-model="organisation.checkoffBankSwiftCode"
					  v-validate="organisation.organisationTypeId === 4 ? 'required' : ''"
					  :error-messages="errors.collect('checkoffBankSwiftCode')"
					  disabled
					>
					</v-text-field>
				  </v-flex>
				  <v-flex xs6>
					<v-autocomplete
					  name="checkoffCurrency"
					  v-model="organisation.checkoffCurrency"
					  :items="currencies"
					  label="Currency"
					  v-validate="organisation.organisationTypeId === 4 ? 'required' : ''"
					  :error-messages="errors.collect('checkoffCurrency')"
					>
					</v-autocomplete>
				  </v-flex>
          <v-flex xs6 v-if="organisation.organisationTypeId == 4 || organisation.organisationTypeId == 11">
            <v-autocomplete
              name="broker"
              v-model="selectedBrokerId"
              :items="brokers"
              item-text="organisationName"
              item-value='id'
              label="Broker"
              v-validate="'required'"
              @change="onBrokerSelected">
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 class="text-xs-right" v-if="organisation.organisationTypeId == 4 || organisation.organisationTypeId == 11">
            <v-btn type="button" color="primary" @click="addOrganization" rounded>
              Add Details
            </v-btn>
          </v-flex>
          <v-flex xs12 v-if="organisation.organisationTypeId == 4 || organisation.organisationTypeId == 11">
            <!-- Table -->
            <table class="details-table">
              <thead>
              <tr>
                <th>Account No</th>
                <th>Account Name</th>
                <th>Bank Name</th>
                <th>Bank Swift C</th>
                <th>Currency</th>
                <th>Broker</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in checkoffSettlementDetails" :key="index">
                <td>{{ item.accountNo }}</td>
                <td>{{ item.accountName }}</td>
                <td>{{ item.bankName }}</td>
                <td>{{ item.bankSwift }}</td>
                <td>{{ item.currency }}</td>
                <td>{{ item.broker }}</td>
                <td>
                  <button class="delete-btn" @click="removeBrokerDetails(index)">🗑</button>
                </td>
              </tr>
              </tbody>
            </table>
          </v-flex>
				  <v-flex xs12>
					<v-card-actions>
					  <v-btn @click="e1 = 2" :disabled="submitting">Back</v-btn>
					  <v-spacer> </v-spacer>
<!--            <v-btn color="primary" @click="e1 = 4" rounded v-if="organisation.organisationTypeId == 4">Next</v-btn>-->
            <v-btn color="primary" @click="createOrganization" rounded :loading="submitting" :disabled="submitting">Create Organization</v-btn>
					</v-card-actions>
				  </v-flex>
				</v-layout>
			  </v-container>
			</v-stepper-content>
      </v-stepper-items>
		</v-stepper>
	  </v-form>
	</v-card>
	</v-flex>
	</v-layout>
	</v-container>
	</template>

<script>
import axios from 'axios'
import config from '../../../config'
import { Validator } from 'vee-validate'

export default {
	  name: 'createorganization',
	  data: function () {
		  return {
			county: [],
			subcounty: [],
			checkoffSettlementDetails: [],
			brokerIds: [],
			selectedBrokerId: null,
			ward: [],
			liabilityProviderLoans: [
				{ loanName: '', loanDisburseAccount: '', loanRecoveryAccount: '' }
			],
			  organisation: {
				  organisationName: '',
				  organisationCode: '',
				  organisationTypeId: '',
				  identificationDocumentID: '',
				  dateOfIncorporation: '',
				  address: '',
				  postalCode: '',
				//   settlementAccount: {},
				  millerId: '',
				  brokerId: '',
				  warehouseId: '',
				  tax: '',
				  kraPin: '',
				  vatApplic: '',
				  vatRate: '',
				  brokerCode: '',
				  broker: '',
		  parentId: null
			  },
			  loader: false,
			  bank: {
				  bankName: '',
				  bankSwiftCode: '',
				  bankCode: '',
				  pic: ''
			  },
			selectedParentOrganisation: null, // new
			  defaultForm: Object.assign({}, this.organization),
			  institutionTypes: [],
			  identificationDocuments: [],
			  message: '',
			  snackbar: false,
			  snackbarColor: '',
			  startDateMenu: false,
			  startDate: null,
			  orgId: 0,
			  e1: 1,
			  currencies: [],
			  submitting: false,
			  farmersocieties: [],
			  isChild: false,
			  organisations: [],
			  millers: [],
			  warehouse: [],
			  taxtypes: [],
			  brokers: [],
			  marketers: [],
			  banks: [],
			searchInput: '',
			loading: false,
			checkingOrgExists: false,
			organisationExistsWarning: ''
		  }
	  },
	   computed: {
		isNonCheckoff() {
    return [2, 3, 4, 5, 11].includes(this.organisation.organisationTypeId)
  },

  settlementStepLabel() {
    return this.organisation.organisationTypeId === 1
      ? 'Checkoff Settlement Details'
      : 'Non-checkoff Settlement Details'
  },
		organisationNameUpper: {
		  get() {
			return this.organisation.organisationName;
		  },
		  set(value) {
			this.organisation.organisationName = value.trim().toUpperCase();
		  }
		},
		organisationCodeUpper: {
		  get() {
			return this.organisation.organisationCode;
		  },
		  set(value) {
			this.organisation.organisationCode = value.trim().toUpperCase();
		  }
		}
	  },
	  mounted () {
		  this.getInstitutionTypes()
		  this.getCurrencies()
		this.getCounty()
		  this.getFcs()
		  this.getMillers()
		  this.getWarehouse()
		this.getTaxTypes()
		  this.getBrokers()
		  this.getMarketers()
		  // this.getOrganisations()
		  this.getBanks()
		  Validator.extend('no-1234', {
	  validate: value => value !== '02320750011234',
	  getMessage: field => `${field} cannot be "02320750011234"`
		})
	  },
	  watch: {
		'organisation.organisationCode': function(newVal) {
		  if (newVal && this.organisation.organisationTypeId) {
			this.checkOrganisationExists();
		  } else {
			this.organisationExistsWarning = '';
		  }
		},
		'organisation.organisationTypeId': function(newVal) {
		  if (newVal && this.organisation.organisationCode) {
			this.checkOrganisationExists();
		  } else {
			this.organisationExistsWarning = '';
		  }
		}
	  },
	  methods: {
		checkOrganisationExists () {
		  this.checkingOrgExists = true;
		  this.organisationExistsWarning = '';
		  
		  const url = config.serverURI + '/organization/check-exists';
		  const params = {
			orgCode: this.organisation.organisationCode,
			orgTypeId: this.organisation.organisationTypeId
		  };
		  
		  axios
			.get(url, { params })
			.then(response => {
			  if (response.data.exists) {
				this.organisationExistsWarning = `An organization with code "${this.organisation.organisationCode}" already exists.`;
			  } else {
				this.organisationExistsWarning = '';
			  }
			})
			.catch(error => {
			  console.error('Error checking organization existence:', error);
			  // Silent fail - don't show error to user, just clear the warning
			  this.organisationExistsWarning = '';
			})
			.finally(() => {
			  this.checkingOrgExists = false;
			});
		},
		addLiabilityProviderLoan () {
			this.liabilityProviderLoans.push({ loanName: '', loanDisburseAccount: '', loanRecoveryAccount: '' })
		},
		removeLiabilityProviderLoan (index) {
			console.log()
			if (this.liabilityProviderLoans.length > 1) {
				this.liabilityProviderLoans.splice(index, 1)
			}
		},
	  searchParentOrganisation (query) {
	  if (query && query.length >= 2) {
				this.getFcs(query)
	  }
		},
		removeBrokerDetails (index) {
			this.checkoffSettlementDetails.splice(index, 1)
		},
		onBrokerSelected (brokerId) {
			console.log('brokers > ', this.brokers)
			console.log('brokerId > ', brokerId)

			const broker = this.brokers.find(b => b.id === brokerId)
			console.log('broker > ', broker)
			if (broker) {
				this.organisation.broker = broker.organisationName
				this.organisation.brokerId = broker.id
				this.organisation.brokerCode = broker.organisationCode
			}
		},
		onCountyChange () {
			// Clear dependent selections
			// this.organisation.subCounty = null;
			// this.organisation.ward = null;
			this.subcounty.length = 0
			this.ward.length = 0

			// Get selected county object using its ID
			const selectedCounty = this.county.find(
				county => county.id === this.organisation.countyId
			)

			console.log('selectedCounty - ', selectedCounty)
			const subCounties = selectedCounty.wrsSubCounties
			if (subCounties.length === 0) {
				this.subcounty.push({ id: 0, name: 'Nil' })
				this.ward.push({ id: 0, name: 'Nil' })
			} else {
				this.subcounty = subCounties
			}
		},
		onSubCountyChange () {
			// Clear dependent selections
			// this.organisation.ward = null;
			this.ward.length = 0

			// Get selected county object using its ID
			const selectedSubCounty = this.subcounty.find(
				county => county.id === this.organisation.subCountyId
			)

			const wards = selectedSubCounty.wrsWards
			if (wards.length === 0) {
				this.ward.push({ id: 0, name: 'Nil' })
			} else {
				this.ward = wards
			}
		},
		onlyLetters (event) {
			const char = String.fromCharCode(event.keyCode)
			if (!/^[a-zA-Z\s]*$/.test(char)) {
				event.preventDefault()
			}
		},
		onlyAlphaNumeric (event) {
			const char = String.fromCharCode(event.keyCode)
			if (!/^[a-zA-Z0-9\s]*$/.test(char)) {
				event.preventDefault()
			}
		},
		onlyDigits (e) {
			if (!/[\d]/.test(e.key)) {
				e.preventDefault()
			}
		},
		validatePhone2 (e) {
			let value = e.target.value

			// Remove all non-digit characters
			value = value.replace(/[^0-9]/g, '')

			// Ensure it starts with 0
			if (value && value[0] !== '0') {
				value = '0' + value.replace(/^0+/, '')
			}

			// Limit to 10 digits
			value = value.slice(0, 10)

			// Assign the cleaned value back
			this.organisation.contactPersonPhone = value
		},
		validateContactPersonPhone (e) {
			// Get the character typed
			const char = String.fromCharCode(e.which || e.keyCode)

			// Allow only digits (0–9)
			if (!/^[0-9]$/.test(char)) {
				e.preventDefault()
				return
			}

			// Ensure first character is 0
			const value = e.target.value
			if (value.length === 0 && !/[072]/.test(char)) {
				e.preventDefault()
			}
		},
		handlePasteContactPersonPhone (e) {
			// Get pasted content
			const pastedData = (e.clipboardData || window.clipboardData).getData('text')

			// Reject if it contains non-digits
			if (!/^\d+$/.test(pastedData)) {
				e.preventDefault()
				return
			}

			// Reject if it doesn't start with 0, 7, or 2
			if (!/^[072]/.test(pastedData)) {
				e.preventDefault()
				return
			}

			// Optionally, reject if total length exceeds maxlength (12 here)
			const currentValue = this.organisation.contactPersonPhone || ''
			if ((currentValue.length + pastedData.length) > 12) {
				e.preventDefault()
			}
		},
		onParentSelect (selectedOrg) {
	  if (selectedOrg) {
				this.organisation.parentId = selectedOrg.id // only store ID into form
	  } else {
				this.organisation.parentId = null
	  }
		},
		getFcs (query) {
			this.loading = true
			console.log('Calling with query string', query)
			const url = config.serverURI + `/organization/get-parent-organization?q=${encodeURIComponent(query)}`

			axios.get(url)
	  .then((response) => {
					const results = response.data.map((x) => ({
		  organisationName: `${x.organisationCode} - ${x.organisationName}`,
		  id: x.id
					}))

					// If a selection exists and it's not already in the results, add it
					if (this.selectedParentOrganisation && !results.find(org => org.id === this.selectedParentOrganisation.id)) {
		  results.push(this.selectedParentOrganisation)
					}

					this.farmersocieties = results
	  })
	  .catch((error) => {
					this.$store.dispatch('alert/displayAlert', {
		  snackbar: true,
		  color: 'error',
		  message: error.response?.message || 'Failed to fetch FCS'
					})
	  })
	  .finally(() => {
					this.loading = false
	  })
		},

	  // Modify your search input method

	  validateAccountNumber (noncheckoff, account, orgType) {
			// Logging the input parameters for debugging

			// Check if orgType is not 4
			if (orgType !== 4) {
	  console.log('OrgType is not 4')
	  // If account or noncheckoff matches the invalid value, return false
	  if (account !== '02320750011234' && account !== '02320750031234') {
					console.log('1')
					return true
	  } else if (noncheckoff !== '02320750011234' && noncheckoff !== '02320750031234') {
					console.log('2')
					return true
	  } else if (noncheckoff !== '02320750011234') {
		  console.log('3')
		  return true
	  } else {
		  return false
	  }
	  // Otherwise, validation passes
			} else {
	  console.log('OrgType is 4')
	  // For orgType 4, only check the account 02320750011234
	  if (account !== '02320750011234' && account !== '02320750031234') {
					console.log('3')
					return true
				} else if (account !== '02320750011234') {
	  console.log('4')
	  return true
				} else {
					// Validation passes for orgType 4
					return false
				}
			}
		},
		checkAccountNumber (noncheckoff, account, orgType) {
			// Logging the input parameters for debugging

			// Check if orgType is not 4
	  // If account or noncheckoff matches the invalid value, return false
	  if (noncheckoff !== '02320750011234') {
		  console.log('Non check off is not dss main')
		  if (account !== noncheckoff) {
					console.log('1')
					return true
	  } else {
		  return false
	  }
	  } else {
		  return false
	  }

	  // Otherwise, validation passes
		},

		  addOrganization () {
			  console.log('Settlement checkoff', this.organisation.checkoffAccountNumber)
			  console.log('Settlement Account', this.organisation.account)
		  if (!this.validateAccountNumber(this.organisation.account, this.organisation.checkoffAccountNumber, this.organisation.organisationTypeId)) {
		  this.message = 'Checkoff number cannot be 02320750011234 or 02320750031234.'
		  this.snackbar = true
		  this.snackbarColor = 'error'
		  return
			}
		  if (!this.checkAccountNumber(this.organisation.account, this.organisation.checkoffAccountNumber, this.organisation.organisationTypeId)) {
		  this.message = 'Checkoff and noncheckoff accounts cannot be the same or the noncheckoff account cannot be 02320750011234 .'
		  this.snackbar = true
		  this.snackbarColor = 'error'
		  return
			}
			if ((this.organisation.organisationTypeId !== 4 &&
		this.organisation.organisationTypeId !== 11) && this.file === undefined) {
		  this.message = 'Logo is required.'
		  this.snackbar = true
		  this.snackbarColor = 'error'
		  return
			}
			const parseLiabilityProviderLoans = JSON.stringify(this.liabilityProviderLoans)
			this.organisation.loanDetails = parseLiabilityProviderLoans

			if (this.organisation.organisationTypeId === 12 &&
          this.liabilityProviderLoans.length === 1
			) {
				const loan = JSON.parse(parseLiabilityProviderLoans)
				const loanName = loan[0].loanName
				const loanDisburseAccount = loan[0].loanDisburseAccount
				const loanRecoveryAccount = loan[0].loanRecoveryAccount
				if (loanName === '' || loanDisburseAccount === '' || loanRecoveryAccount === '') {
					this.message = 'Please enter loan checkoffSettlementDetails'
					this.snackbar = true
					this.snackbarColor = 'error'
					return
				}
			}

			if (this.organisation.organisationTypeId === 4 ||
        this.organisation.organisationTypeId === 11) {
				const accountNo = this.organisation.checkoffAccountNumber
				const accountName = this.organisation.checkoffAccountName
				const bankName = this.organisation.checkoffBankName
				const bankSwift = this.organisation.checkoffBankSwiftCode
				const currency = this.organisation.checkoffCurrency
				const broker = this.organisation.broker
			const brokerId = this.organisation.brokerId
			const brokerCode = this.organisation.brokerCode

			if (brokerCode === null || brokerCode === undefined) {
				this.message = 'Please select a broker'
				this.snackbar = true
				this.snackbarColor = 'error'
				return
			}

			const brokerExists = this.checkoffSettlementDetails.some(obj => obj.brokerCode === brokerCode)
			console.log(brokerExists) // true
			if (brokerExists) {
				this.message = 'The broker already exists'
				this.snackbar = true
				this.snackbarColor = 'error'
				return
			}

			const accountDetails = {
				accountNo: accountNo,
				accountName: accountName,
				bankName: bankName,
				bankSwift: bankSwift,
				currency: currency,
				broker: broker,
				brokerId: brokerId,
				brokerCode: brokerCode
			}
 			this.checkoffSettlementDetails.push(accountDetails)
		}

			
		  },
		createOrganization () {
			
			this.$validator.validate().then(result => {

				
  if ([1, 13].includes(this.organisation.organisationTypeId)) {

    this.organisation.checkoffAccountNumber =
      this.organisation.account

    this.organisation.checkoffAccountName =
      this.organisation.accountName

    this.organisation.checkoffBankName =
      this.organisation.bankName

    this.organisation.checkoffBankSwiftCode =
      this.organisation.bankCode

    this.organisation.checkoffCurrency =
      this.organisation.currency

    // Optional: clear non-checkoff fields
    this.organisation.account = null
    this.organisation.accountName = null
    this.organisation.bankName = null
    this.organisation.bankCode = null
    this.organisation.currency = null
  }



				if (result) {
					const url = config.serverURI + '/organization/create'
					this.organisation.dateOfIncorporation = this.startDate
					const formData = new FormData()
					formData.append('file', this.file)
					formData.append('organisation', JSON.stringify(this.organisation))
					formData.append('checkoffdetails', JSON.stringify(this.checkoffSettlementDetails))
					console.log(JSON.stringify(this.organisation))
					this.submitting = true
					axios.post(url, formData)
						.then(response => {
							console.log('hello world => ', response)
							if (response.data.error !== false) {
								this.message = response.data.message
								this.snackbar = true
								this.snackbarColor = 'error'
								return
							}
							this.resetForm()
							this.message = response.data.message
							this.snackbar = true
							this.snackbarColor = 'primary'
							this.e1 = 1
							this.$validator.reset()
							this.liabilityProviderLoans = [{ loanName: '', loanDisburseAccount: '', loanRecoveryAccount: '' }]
						})
						.catch(error => {
							console.log('error', error.response)
							this.message = error.response.data.message
							this.snackbar = true
							this.snackbarColor = 'error'
						})
						.finally(() => {
							this.submitting = false
						})
					this.handleFileUpload()
				}
			})
		},
		  getBanks () {
			  const url = config.serverURI + '/bank'
			  axios.get(url)
				  .then(response => {
					  this.banks = response.data
				  })
				  .catch(error => {
					  console.log('error', error.response)
				  })
		  },
		  resetForm () {
			  this.organization = Object.assign({}, this.defaultForm)
			  this.$refs.form.reset()
		  },
		validateAlphanumeric () {
			// Allow only starting with 0 followed by 1-9a-zA-Z
			const regex = /^[0-9a-zA-Z]*$/

			if (this.inputValue === '') {
				this.error = ''
				return
			}

			if (!regex.test(this.inputValue)) {
				this.error = 'Input must start with 0 and only contain letters (a-z, A-Z) and digits (1-9)'
				// Optionally remove invalid characters
				this.inputValue = this.inputValue.replace(/[^0-9a-zA-Z]/gi, '')
				if (!this.inputValue.startsWith('0')) {
					this.inputValue = '0' + this.inputValue
				}
			} else {
				this.error = ''
			}
		},
		validateInputContactPhoneNumber (event) {
			const value = event.target.value

			// Check if empty
			if (value === '') {
				this.clearError()
				return
			}

			// Check if all characters are digits
			if (!/^\d+$/.test(value)) {
				this.showError('Only integers are allowed')
				return
			}

			// Check if starts with 0
			if (!value.startsWith('0')) {
				this.showError('Must start with 0')
				return
			}

			this.clearError()
		},
		  getInstitutionTypes () {
			  var url = config.serverURI + '/instution/get'
			  axios.get(url)
				  .then(response => {
					  if (response.status !== 200) {
						  console.log('Error is ' + this.error)
						  return
					  }
					  this.institutionTypes = response.data
				  })
				  .catch(error => {
					  console.log('error', error.response)
				  })
		  },
		  getCurrencies () {
			  var url = config.serverURI + '/organization/currency'
			  axios.get(url)
				  .then(response => {
					  if (response.status !== 200) {
						  console.log('Error is ' + this.error)
						  return
					  }
					  this.currencies = response.data
				  })
				  .catch(error => {
					  console.log('error', error.response)
				  })
		  },
		getCounty () {
			var url = config.serverURI + '/county/findAll'
			axios.get(url)
				.then(response => {
					console.log('=====>> ', response.data)
					if (response.status !== 200) {
						console.log('Error is ' + this.error)
						return
					}
					// response.data.forEach(x => {
					//   this.county.push(x.name)
					// })
					this.county = response.data

					// this.currencies = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},

		  getMillers: function () {
			  const url = config.serverURI + '/organization/getMillers'
			  axios.post(url)
				  .then(response => {

					  this.millers = response.data
					  console.log('millers - ', this.millers)
				  })
				  .catch(error => {
					  this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				  })
			  return this.organisations
		  },
		  getBrokers: function () {
			  const url = config.serverURI + '/organization/get-marketers'
			  axios.get(url)
				  .then(response => {
					  this.brokers = response.data
					console.log('brokers - ', this.brokers)
				  })
				  .catch(error => {
					  this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				  })
			  return this.organisations
		  },
		getMarketers: function () {
			const url = config.serverURI + '/organization/get-marketers'
			axios.get(url)
				.then(response => {
					this.marketers = response.data
					console.log('marketers - ', this.marketers)
				})
				.catch(error => {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
			return this.organisations
		},
		  getWarehouse: function () {
			  const url = config.serverURI + '/organization/getWarehouse'
			  axios.post(url)
				  .then(response => {
					  this.warehouse = response.data
					  console.log('warehouse - ', this.warehouse)
				  })
				  .catch(error => {
					  this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				  })
			  return this.organisations
		  },
		getTaxTypes: function () {
			const url = config.serverURI + '/taxtypes/findAll'
			axios.get(url)
				.then(response => {
					this.taxtypes = response.data
				})
				.catch(error => {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
			return this.organisations
		},
		  handleFileUpload () {
			  this.file = this.$refs.file.files[0]
		  },

		  updateSwiftCode () {
			  // Find the selected bank
			  const selectedBank = this.banks.find(bank => bank.bankName === this.organisation.bankName)

			  // Update the bank Swift Code
			  if (selectedBank) {
				  this.bank.bankSwiftCode = selectedBank.bankSwiftCode
				  this.organisation.bankCode = selectedBank.bankSwiftCode
				  this.bank.pic = selectedBank.pic
				  if (this.bank.pic === '0011') {
					  this.loader = true
					  const url = config.serverURI + '/organization/validateAccountDetails'
					  const data = {
						  organisationType: this.organisation.organisationTypeId,
						  accountNumber: this.organisation.account

					  }

					  axios.post(url, data)
						  .then(response => {
							  this.loader = false
							  console.log('validationzz response ', response)
							  if (response.data.accountName === null) {
								  this.message = 'Account Details Missing'
								  this.snackbar = true
								  this.snackbarColor = 'error'
								  this.organisation.accountName = ''
								  console.log('Error is Account Details Missing')
								  return
							  }
							  this.message = 'Account Details validated successfully. '
							  console.log('registrationResponse ', response.data.registrationResponse.trim())
							  // this.message = 'Account Details validated successfully'+ ' ' + response.data.registrationResponse
							  if (response.data.registrationResponse.trim() == 'Account Enrolled successfully for the alert' ||
					  response.data.registrationResponse.trim() == 'Alert registration successful') {
								  this.message += 'Account alert registered successfully.'
								  console.log('one')
							  } else if (response.data.registrationResponse.trim() == 'Account Already registered for the alert and channelID selected update will be done') {
								  this.message += 'Account already registered for alerts.'
								  console.log('one2')
							  } else {
								  this.message += 'Account not registered for alerts.'
								  console.log('one3')
							  }
							  console.log('message ', this.message)
							  this.snackbar = true
							  this.snackbarColor = 'primary'
							//   this.organisation.accountName = 'Test account'
							  this.organisation.accountName = response.data.accountName
						  })
						  .catch(error => {
							  this.loader = false
							  console.log('error', error.response)
							  this.message = error.response.message
							  this.snackbar = true
							  this.snackbarColor = 'error'
						  })
				  } else {
					  const url = config.serverURI + '/organization/validateIpslAccountDetails'
					  console.log(this.bank.pic)
					  axios.post(url, { accountNumber: this.organisation.account, pic: this.bank.pic })
						  .then(response => {
							  if (response.data.accountName === null || response.data.accountName === 'Whitelist') {
								  this.message = 'Account Details Missing'
								  this.organisation.accountName = ''
								  this.snackbar = true
								  this.snackbarColor = 'error'
								  console.log('Error is Account Details Missing')
								  return
							  }
							  this.message = 'Account Details validated successfully'
							  this.snackbar = true
							  this.snackbarColor = 'primary'
							//   this.organisation.accountName = "Test account"
							  this.organisation.accountName = response.data.accountName
						  })
						  .catch(error => {
							  console.log('error', error.response)
							  this.message = error.response.message
							  this.snackbar = true
							  this.snackbarColor = 'error'
						  })
				  }
			  } else {
				  this.organisation.bankCode = '' // Reset if the bank is not found
			  }
		  },
		  validateAccountNumber (value) {
			if (!value) {
		  return 'Account number is required.'
			}
		// 	if (!value.startsWith('02')) {
		//   return 'Valid dollar accounts start with 02.'
		// 	}
			return true
	  },
		  checkoffUpdateSwiftCode () {
			  // Find the selected bank
			  const selectedBank = this.banks.find(bank => bank.bankName === this.organisation.checkoffBankName)

			  // Update the bank Swift Code
			  if (selectedBank) {
				  this.bank.bankSwiftCode = selectedBank.bankSwiftCode
				  this.organisation.checkoffBankSwiftCode = selectedBank.bankSwiftCode
				  this.bank.pic = selectedBank.pic
				  if (this.bank.pic === '0011') {
					  const data = {
						  organisationType: 0,
						  accountNumber: this.organisation.checkoffAccountNumber

					  }
					  const url = config.serverURI + '/organization/validateAccountDetails'

					  console.log('The checkoff account being validate', this.organisation.checkoffAccountNumber)

					  axios.post(url, data)
						  .then(response => {
							  if (response.data.accountName === null) {
								  this.message = 'Account Details Missing'
								  this.snackbar = true
								  this.snackbarColor = 'error'
								  this.organisation.checkoffAccountName = ''
								  console.log('Error is Account Details Missing')
								  return
							  }
							  this.message = 'Account Details validated successfully'
							  this.snackbar = true
							  this.snackbarColor = 'primary'
							  this.organisation.checkoffAccountName = response.data.accountName
						  })
						  .catch(error => {
							  console.log('error', error.response)
							  this.message = error.response.message
							  this.snackbar = true
							  this.snackbarColor = 'error'
						  })
				  } else {
					  const url = config.serverURI + '/organization/validateIpslAccountDetails'
					  console.log(this.bank.pic)
					  axios.post(url, { accountNumber: this.organisation.account, pic: this.bank.pic })
						  .then(response => {
							  if (response.data.accountName === null || response.data.accountName === 'Whitelist') {
								  this.message = 'Account Details Missing'
								  this.organisation.checkoffAccountName = ''
								  this.snackbar = true
								  this.snackbarColor = 'error'
								  console.log('Error is Account Details Missing')
								  return
							  }
							  this.message = 'Account Details validated successfully'
							  this.snackbar = true
							  this.snackbarColor = 'primary'
							  this.organisation.checkoffAccountName = response.data.accountName
						  })
						  .catch(error => {
							  console.log('error', error.response)
							  this.message = error.response.message
							  this.snackbar = true
							  this.snackbarColor = 'error'
						  })
				  }
			  } else {
				  this.organisation.bankCode = '' // Reset if the bank is not found
			  }
		  },

		farmerUsdUpdateSwiftCode () {
			// Find the selected bank
			const selectedBank = this.banks.find(bank => bank.bankName === this.organisation.farmerUsdBankName)

			// Update the bank Swift Code
			if (selectedBank) {
				this.bank.bankSwiftCode = selectedBank.bankSwiftCode
				this.organisation.farmerUsdBankSwiftCode = selectedBank.bankSwiftCode
				this.bank.pic = selectedBank.pic
				if (this.bank.pic === '0011') {
					const data = {
						organisationType: 0,
						accountNumber: this.organisation.farmerUsdAccountNumber

					}
					const url = config.serverURI + '/organization/validateAccountDetails'

					console.log('The farmerUsd account being validate', this.organisation.farmerUsdAccountNumber)

					axios.post(url, data)
						.then(response => {
							if (response.data.accountName === null) {
								this.message = 'Account Details Missing'
								this.snackbar = true
								this.snackbarColor = 'error'
								this.organisation.farmerUsdAccountName = ''
								console.log('Error is Account Details Missing')
								return
							}
							this.message = 'Account Details validated successfully'
							this.snackbar = true
							this.snackbarColor = 'primary'
							this.organisation.farmerUsdAccountName = response.data.accountName
						})
						.catch(error => {
							console.log('error', error.response)
							this.message = error.response.message
							this.snackbar = true
							this.snackbarColor = 'error'
						})
				} else {
					const url = config.serverURI + '/organization/validateIpslAccountDetails'
					console.log(this.bank.pic)
					axios.post(url, { accountNumber: this.organisation.farmerUsdAccountNumber, pic: this.bank.pic })
						.then(response => {
							if (response.data.accountName === null || response.data.accountName === 'Whitelist') {
								this.message = 'Account Details Missing'
								this.organisation.farmerUsdAccountName = ''
								this.snackbar = true
								this.snackbarColor = 'error'
								console.log('Error is Account Details Missing')
								return
							}
							this.message = 'Account Details validated successfully'
							this.snackbar = true
							this.snackbarColor = 'primary'
							this.organisation.farmerUsdAccountName = response.data.accountName
						})
						.catch(error => {
							console.log('error', error.response)
							this.message = error.response.message
							this.snackbar = true
							this.snackbarColor = 'error'
						})
				}
			} else {
				this.organisation.bankCode = '' // Reset if the bank is not found
			}
		},

		farmerKesUpdateSwiftCode () {
			// Find the selected bank
			const selectedBank = this.banks.find(bank => bank.bankName === this.organisation.farmerKesBankName)

			// Update the bank Swift Code
			if (selectedBank) {
				this.bank.bankSwiftCode = selectedBank.bankSwiftCode
				this.organisation.farmerKesBankSwiftCode = selectedBank.bankSwiftCode
				this.bank.pic = selectedBank.pic
				if (this.bank.pic === '0011') {
					const data = {
						organisationType: 0,
						accountNumber: this.organisation.farmerKesAccountNumber

					}
					const url = config.serverURI + '/organization/validateAccountDetails'

					console.log('The farmerUsd account being validate', this.organisation.farmerKesAccountNumber)

					axios.post(url, data)
						.then(response => {
							if (response.data.accountName === null) {
								this.message = 'Account Details Missing'
								this.snackbar = true
								this.snackbarColor = 'error'
								this.organisation.farmerKesAccountName = ''
								console.log('Error is Account Details Missing')
								return
							}
							this.message = 'Account Details validated successfully'
							this.snackbar = true
							this.snackbarColor = 'primary'
							this.organisation.farmerKesAccountName = response.data.accountName
						})
						.catch(error => {
							console.log('error', error.response)
							this.message = error.response.message
							this.snackbar = true
							this.snackbarColor = 'error'
						})
				} else {
					const url = config.serverURI + '/organization/validateIpslAccountDetails'
					console.log(this.bank.pic)
					axios.post(url, { accountNumber: this.organisation.farmerKesAccountNumber, pic: this.bank.pic })
						.then(response => {
							if (response.data.accountName === null || response.data.accountName === 'Whitelist') {
								this.message = 'Account Details Missing'
								this.organisation.farmerKesAccountName = ''
								this.snackbar = true
								this.snackbarColor = 'error'
								console.log('Error is Account Details Missing')
								return
							}
							this.message = 'Account Details validated successfully'
							this.snackbar = true
							this.snackbarColor = 'primary'
							this.organisation.farmerKesAccountName = response.data.accountName
						})
						.catch(error => {
							console.log('error', error.response)
							this.message = error.response.message
							this.snackbar = true
							this.snackbarColor = 'error'
						})
				}
			} else {
				this.organisation.bankCode = '' // Reset if the bank is not found
			}
		}

	  }
}

</script>
	<style>

  .details-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }

  .details-table th,
  .details-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  .delete-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
  }

  .submitting-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .submitting-message {
    text-align: center;
  }

  .text-xs-right  { text-align: right !important; }
	</style>
